import React from "react";
import { FormHelperText } from "@mui/material";

interface ErrorMessageProps {
  touched?: boolean;
  error?: string | undefined; // validation error message
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ touched, error }) => {
  if (!touched || !error) return null; // only show if touched and has error

  return <FormHelperText error>{error}</FormHelperText>;
};

export default ErrorMessage;
